// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import DatatableController from "./datatable_controller"
application.register("datatable", DatatableController)

import Components__DrawerController from "./components/drawer_controller"
application.register("components--drawer", Components__DrawerController)

import Components__ModalController from "./components/modal_controller"
application.register("components--modal", Components__ModalController)

import Components__SegmentedToggleController from "./components/segmented_toggle_controller"
application.register("components--segmented-toggle", Components__SegmentedToggleController)

import Components__SelectPillsController from "./components/select_pills_controller"
application.register("components--select-pills", Components__SelectPillsController)

import Components__StateSelectController from "./components/state_select_controller"
application.register("components--state-select", Components__StateSelectController)

import Dashboard__ChartController from "./dashboard/chart_controller"
application.register("dashboard--chart", Dashboard__ChartController)

import Dashboard__StreamController from "./dashboard/stream_controller"
application.register("dashboard--stream", Dashboard__StreamController)

import Forms__CiotController from "./forms/ciot_controller"
application.register("forms--ciot", Forms__CiotController)

import Forms__ClientStayController from "./forms/client_stay_controller"
application.register("forms--client-stay", Forms__ClientStayController)

import Forms__DriverStayController from "./forms/driver_stay_controller"
application.register("forms--driver-stay", Forms__DriverStayController)

import Forms__RouteSectionController from "./forms/route_section_controller"
application.register("forms--route-section", Forms__RouteSectionController)

import Forms__ScheduleController from "./forms/schedule_controller"
application.register("forms--schedule", Forms__ScheduleController)

import Pages__RouteSectionController from "./pages/route_section_controller"
application.register("pages--route-section", Pages__RouteSectionController)
